var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32517 8.17773L14.2998 2.41884C14.3832 2.32313 14.313 2.17773 14.1842 2.17773H12.6719C12.5828 2.17773 12.4976 2.21638 12.4388 2.28264L8.33594 7.03295L4.23307 2.28264C4.17622 2.21638 4.09094 2.17773 3.99998 2.17773H2.4877C2.35883 2.17773 2.28871 2.32313 2.3721 2.41884L7.3467 8.17773L2.3721 13.9366C2.35342 13.958 2.34143 13.984 2.33757 14.0118C2.3337 14.0395 2.33812 14.0678 2.35029 14.0932C2.36246 14.1186 2.38188 14.14 2.40623 14.155C2.43059 14.17 2.45886 14.1779 2.4877 14.1777H3.99998C4.08905 14.1777 4.17433 14.1391 4.23307 14.0728L8.33594 9.32252L12.4388 14.0728C12.4957 14.1391 12.5809 14.1777 12.6719 14.1777H14.1842C14.313 14.1777 14.3832 14.0323 14.2998 13.9366L9.32517 8.17773Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fd93ccddce662597285865697492ce77.svg";
export { ForwardRef as ReactComponent };